// Student and other users

import auth from '../helper/auth'
import TicketDetailsStaff from '../views/user/TicketDetailsUser.vue'
import ChangePasswordStaff from '../views/ChangePassword.vue'
import TicketsStaff from '../views/user/TicketsUser.vue'
import ProfileStaff from '../views/Profile.vue'
import StaffLayout from '../layouts/Staff.vue'

const userRoutes = [
  {
    path: '/staff',
    component: StaffLayout,
    beforeEnter: auth.ifAuthenticated,
    children: [
      {
        path: '/',
        name: 'HomeStaff',
        component: TicketsStaff
      },
      {
        path: 'profile',
        name: 'ProfileStaff',
        component: ProfileStaff
      },
      {
        path: 'tickets/:status', // status is sticket state e.g. open, closed, escalated
        name: 'TicketsStaff',
        component: TicketsStaff
      },
      {
        path: 'ticket/:ref',
        name: 'TicketDetailsStaff',
        component: TicketDetailsStaff
      },
      {
        path: 'change-password',
        name: 'ChangePasswordStaff',
        component: ChangePasswordStaff
      }
    ]
  }
]

export default userRoutes
